import React, {useEffect, useRef} from "react"
import "./SideLabel.css"

interface SideLabelProps{
    currentSection:number;
}

const SideLabel:React.FC<SideLabelProps> = (props) => {
    const labelR = ["Hello World!","Who Am I?","Works","Label","Contact"];
    const labelL = ["Hello World!","自己紹介","制作物","汎化部門","連絡先"];
    return(
        <React.Fragment>
            <div className={"SideLabel R Active"}>
            </div>
            <div className={"SideLabel L Active"}>
            </div>
            {labelR.map((e,i) => {
                const state = i == props.currentSection
                const color = i % 3 == 0 ? "#1a1a1a" : (i % 3 == 1 ? "#fa003c":"#00b7fa");
                const stateText = state ? "Active" : (i < props.currentSection ?  "Higher" : "Lower");
                return(
                    <React.Fragment>
                        <div className={"SideLabel R " + stateText} style={{backgroundColor:color}}>
                            <div className={"SideLabelContent R"}>
                                {state ? labelR[i] : ""}
                            </div>
                        </div>
                        <div className={"SideLabel L " + stateText} style={{backgroundColor:color}}>
                            <div className={"SideLabelContent R"}>
                                {state ? labelL[i] : ""}
                            </div>
                        </div>
                    </React.Fragment>
                )
            })}
        </React.Fragment>
    )
}

export default SideLabel;